import React from "react";
import { CalculateSpacing } from "../editor/Helpers";
import * as Opt from "../editor/Helpers";
import MediaSelector from '../editor/fields/MediaSelector';
import { LoginContext } from "../login/context/LoginContext";

class Button extends React.Component {
    static contextType = LoginContext;

    constructor() {
        super();
    }

    handleClick(e, button) {
        const LoginContext = this.context;

        if(!LoginContext.userData.is_logged && button.href.includes('min-skog')) {
            e.preventDefault();
            LoginContext.open({next_url: button.href})
        }
    }

    render() {
        return (
            <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : ''} flex flex-col lg:flex-row gap-1 lg:gap-3 ${Opt.toTailwindClasses(this.props.horizontalAlignContent)} items-start`}>
                {this.props.buttons.map((button) => {
                    return <a href={button.href} onClick={(e) => this.handleClick(e, button)} style={{ minWidth: button.minWidth }} className={`n-btn gap-1-5 shrink-0 flex items-center justify-center ${button.fullWidthOnMobile} ${button.size} ${button.variant} ${button.style} ${CalculateSpacing(button.spacing)} `} target={`${button.target}`} >
                            {button.iconBefore && <span><img className={` ${button.iconColor}`} style={{ width: "18px", height: "18px" }} src={button.iconBefore} /></span>}
                            {button.text}
                            {button.iconAfter && <span><img className={`${button.iconColor}`} style={{ width: "18px", height: "18px" }} src={button.iconAfter} /></span>}
                        </a>
                })}
            </div>
            )
    }
}

Button.defaultProps = {
    visibility: "",
    horizontalAlignContent: "justify-between",
    buttons: [{
        text: "Action",
        href: "/",
        variant: "btn-core",
        style: "",
        target: "_self",
        size: "",
        spacing: [],
        iconBefore: null,
        iconAfter: null,
        iconColor: "white-filter",
        minWidth: "",
        fullWidthOnMobile: ""
    }]
};

Button.fields = {
    visibility: {
        type: "select",
        options: Opt.visibilityOptions
      },
    horizontalAlignContent: {
        type: "select",
        options: Opt.contentJustify
    },
    buttons: {
        type: "array",
        arrayFields: {
            href: { type: "text" },
            text: { type: "text" },
            variant: { type: "select", options: Opt.buttonOptions },
            style: { type: "select", options: Opt.buttonStyle },
            target: { type: "select", options: Opt.targetOptions },
            size: { type: "select", options: Opt.buttonSize },
            spacing: Opt.spacingOptions,
            iconBefore: {
                type: "custom",
                render: ({ name, onChange, value }) => <MediaSelector name={'iconBefore'} type={'icon'} onChange={onChange} value={value} />,
            },
            iconAfter: {
                type: "custom",
                render: ({ name, onChange, value }) => <MediaSelector name={'iconAfter'} type={'icon'} onChange={onChange} value={value} />,
            },
            iconColor: {
                type: "select",
                options: Opt.filterOptions
            },
            minWidth: {
                type: "text"
            },
            fullWidthOnMobile: {
                type: "radio",
                  options: [
                    { label: "No", value: "" },
                    { label: "Yes", value: "w-full lg:w-auto" },
                  ],
            }
        },
        defaultItemProps: Button.defaultProps.buttons[0],
        getItemSummary: (button) => "Button",
    }

}
export default Button;